import React from 'react'

import { AdminHeader, Layout } from 'components'

import { Users } from 'modules/Users/containers'

const UsersPage = () => (
  <Layout>
    <AdminHeader />
    <Users />
  </Layout>
)

export default UsersPage
